import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <ContactSection />
        <FAQSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <MediaSection />
        <TopicsSection />
        <AppSection />
        <UpdatesSection />
        <RankingSection />
        <CommentsSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}